<script>
    export default {
        name: "TxSettingsUi",
        data() {
            return {
                type: 'accordion',
            }
        },
        render(createElement, context) {
            return createElement(
                `${this.type}Type`,
                this.$slots.default.map((item) => {
                    return item.tag ? createElement(
                        `${this.type}Component`,
                        {
                            props: {
                                ...item?.data?.attrs
                            }
                        },
                        item.children
                    ) : null
                })
            )
        },
        mounted() {
            window.addEventListener('resize', this.onResizeEnd);
            this.onResizeEnd();
        },
        methods: {
            onResizeEnd() {
                if (window.matchMedia("print, screen and (min-width: 1024px)").matches) {
                    this.type = "accordion";
                } else {
                    this.type = "tab";
                }
            },
        },
    }
</script>

<style scoped>

</style>